import { cliente } from '@/lib/cliente';
import type { ActualizarUsuario, CrearUsuario, ResetPin } from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useUsuarios() {
  return useQuery({
    queryKey: ['usuarios'],
    queryFn: () => cliente.usuarios.listar(),
  });
}

export function useCrearUsuario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CrearUsuario) => cliente.usuarios.crear(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}

export function useActualizarUsuario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ActualizarUsuario }) =>
      cliente.usuarios.actualizar(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}

export function useResetPin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ResetPin }) =>
      cliente.usuarios.resetPin(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}

export function useDesbloquearUsuario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => cliente.usuarios.desbloquear(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['usuarios'] }),
  });
}
